import * as Yup from 'yup';

/**
 * Définition des règles de validation de mot de passe
 */
export const PASSWORD_RULES = {
  minLength: {
    id: 'minLength',
    minLength: 12,
    validate: (password) => password.length >= 12,
  },
  maxLength: {
    id: 'maxLength',
    maxLength: 128,
    validate: (password) => password.length <= 128,
  },
  lowercase: {
    id: 'lowercase',
    pattern: /[a-z]/,
    validate: (password) => /[a-z]/.test(password),
  },
  uppercase: {
    id: 'uppercase',
    pattern: /[A-Z]/,
    validate: (password) => /[A-Z]/.test(password),
  },
  numbers: {
    id: 'numbers',
    pattern: /\d/,
    validate: (password) => /\d/.test(password),
  },
  symbols: {
    id: 'symbols',
    pattern: /[!@#$%^&*(),.?":{}|<>+\-_=[\]/\\;:'"`~]/,
    validate: (password) => /[!@#$%^&*(),.?":{}|<>+\-_=[\]/\\;:'"`~]/.test(password),
  },
};

/**
 * Vérifie si un mot de passe respecte toutes les règles de validation
 */
export const isPasswordValid = (password) => {
  if (!password) return false;
  
  // Vérifier toutes les règles
  return Object.values(PASSWORD_RULES).every(rule => rule.validate(password));
};

/**
 * Obtient les règles de validation de mot de passe avec leur état (valide/invalide)
 */
export const getPasswordRules = (password) => {
  return Object.values(PASSWORD_RULES).map(rule => ({
    id: rule.id,
    valid: rule.validate(password),
  }));
};

/**
 * Crée un validateur Yup pour les mots de passe
 */
export const createPasswordValidator = (t, isRequired = false) => {
  let validator = isRequired 
    ? Yup.string().required(t('This field is required'))
    : Yup.string().nullable();
  
  return validator.test(
    'password-validation',
    t('Password does not meet the requirements'),
    (value) => {
      // Si le champ n'est pas requis et qu'il est vide, on le considère comme valide
      if (!isRequired && (!value || value === '')) {
        return true;
      }
      
      return isPasswordValid(value);
    }
  );
}; 